export const SET_CLIENT_MONITOR_CART_STATE = 'SET_CLIENT_MONITOR_CART_STATE'

export const SHOW_CLIENT_MONITOR_FINAL_STEP = 'SHOW_CLIENT_MONITOR_FINAL_STEP'

export const SET_CLIENT_MONITOR_QR_CODE_PAYMENT_SESSION = 'SET_CLIENT_MONITOR_QR_CODE_PAYMENT_SESSION'
